import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth/auth.guard';
import { NotFoundComponent } from './core/components/not-found/not-found.component';


const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  {
    path: 'login',
    loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'gestao-medica',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/gestao-medica/gestao-medica.module').then((m) => m.GestaoMedicaModule),
  },
  {
    path: 'pre-cadastro',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/pre-cadastro/pre-cadastro.module').then((m) => m.PreCadastroModule),
  },
  {
    path: 'comunicados',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/comunicados/comunicados.module').then((m) => m.ComunicadosModule),
  },
  {
    path: 'atendimento',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/atendimento/atendimento.module').then((m) => m.AtendimentoModule),
  },
  {
    path: 'controle-usuarios',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/controle-usuarios/controle-usuarios.module').then(
        (m) => m.ControleUsuariosModule
      ),
  },
  {
    path: 'titulos-pendentes',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/titulos-pendentes/titulos-pendentes.module').then(
        (m) => m.TitulosPendentesModule
      ),
  },
  {
    path: 'extratos',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/extratos/extratos.module').then((m) => m.ExtratosModule),
  },
  {
    path: 'proposta-migracao',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/proposta-migracao/proposta-migracao.module').then(
        (m) => m.PropostaMigracaoModule
      ),
  },
  {
    path: 'ia-retencao',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/ia-retencao/ia-retencao.module').then((m) => m.IaRetencaoModule),
  },
  {
    path: 'financeiro',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/financeiro/financeiro.module').then((m) => m.FinanceiroModule),
  },
  {
    path: 'modelo-proposta',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/modelo-proposta/modelo-proposta.module').then(
        (m) => m.ModeloPropostaModule
      ),
  },
  {
    path: 'estudos-migracao',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/estudos-migracao/estudos-migracao.module').then(
        (m) => m.EstudosMigracaoModule
      ),
  },
  {
    path: 'venda-online',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/venda-online/venda-online.module').then((m) => m.VendaOnlineModule),
  },
  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
